<template>
  <div class="module-animation">
    <label class="module-animation__label">
      {{ $t('Entrance') }}

      <NebulaSelect class="module-animation__select">
        <template #select>
          <select
            class="nebula-select__element"
            :value="entrance"
            @change="entrance = $event.target.value"
          >
            <NebulaSelectOption
              v-for="option in animationOptions"
              :key="option.value"
              :option="option"
            />
          </select>
        </template>
      </NebulaSelect>
    </label>
    <label class="module-animation__label">
      {{ $t('Hover') }}

      <NebulaSelect class="module-animation__select">
        <template #select>
          <select
            class="nebula-select__element"
            :value="hover"
            @change="hover = $event.target.value"
          >
            <NebulaSelectOption
              v-for="option in animationOptions"
              :key="option.value"
              :option="option"
            />
          </select>
        </template>
      </NebulaSelect>
    </label>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import {
  get, cloneDeep, find, set,
} from 'lodash-es';
import {
  NebulaSelect,
  NebulaSelectOption,
} from '@discoveryedu/nebula-components';
import {
  useEditorStore,
} from '@/stores';
import * as types from '@/lib/constants/store';

function createAnimationComputedProperty(trigger) {
  return {
    get() {
      return get(find(this.animations, (item) => item.trigger === trigger), 'type', 'none');
    },
    set(value) {
      const animations = cloneDeep(this.animations)
        .filter((item) => item.trigger !== trigger);
      if (value && value !== 'none') animations.push({ trigger, type: value });
      this.animations = animations;
    },
  };
}

export default {
  components: {
    NebulaSelect,
    NebulaSelectOption,
  },
  props: {
    canvasName: {
      type: String,
      required: true,
    },
    moduleData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      animationOptions: [
        { text: this.$t('None'), value: 'none' },
        { text: this.$t('Pulse'), value: 'pulse' },
        { text: this.$t('Tada'), value: 'tada' },
        { text: this.$t('Rubber Band'), value: 'rubberband' },
      ],
    };
  },
  computed: {
    ...mapState(useEditorStore, [
      'getModuleById',
    ]),
    moduleId() {
      return get(this, 'moduleData.id');
    },
    animations: {
      get() {
        return get(this, 'moduleData.options.animations', []);
      },
      set(value) {
        const modToUpdate = cloneDeep(this.getModuleById(this.moduleId));
        if (!modToUpdate) return;
        set(modToUpdate, 'options.animations', value);
        this[types.UPDATE_MODULES]({
          canvasName: this.canvasName,
          modules: [modToUpdate],
        });
      },
    },
    entrance: createAnimationComputedProperty('entrance'),
    hover: createAnimationComputedProperty('hover'),
  },
  methods: {
    ...mapActions(useEditorStore, [
      types.UPDATE_MODULES,
    ]),
  },
};
</script>

<style lang="stylus">
.module-animation {
  align-items: center;
  display: flex;

  &__label {
    flex: 1 1 50%;
    font-size: $nebula-font-size-body-2;
    font-weight: 500; // matching other labels in module options
    padding: 0 $nebula-space-1x;
  }

  &__select {
    margin-bottom: 0;
    margin-top: $nebula-space-1x;
  }
}
</style>
